import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import type Survey from 'modules/surveys/store/models/v2/Survey'

interface Props {
  survey: Survey
}

export default function AddEditorModal({ survey }: Props) {
  const { navigation } = useNavigation()

  const [userId, setUserId] = React.useState<string>()
  const [running, setRunning] = React.useState<boolean>(false)
  const navigate = useNavigate()
  const surveyId = String(survey.attributes.id)

  const onClose = () => {
    const route = navigation.engagement.surveys.id.configuration.fullPath({ id: surveyId })
    navigate(route)
  }

  const submit = async (closePortal: ClosePortalFn) => {
    setRunning(true)

    const { success } = await asyncAction(() =>
      survey.rpc('supervisors', {
        access_id: userId,
        form_id: surveyId,
      })
    )
    setRunning(false)

    if (success) {
      survey.fetch({
        data: {
          surveys_form_id: surveyId,
        },
      })
      closePortal()
    }
  }

  const memberIds = survey.attributes.supervisor_ids ?? []

  return (
    <Modal
      title={i18n.t('surveys.form.add_manager.title')}
      description={i18n.t('surveys.form.add_manager.description')}
      illustration="surveys"
      onClose={onClose}
      onSubmit={submit}
      footer={
        <Button disabled={!userId || running} type="primary" aria-label="Add Editor button" submit>
          {i18n.t('surveys.form.add_manager.submit')}
        </Button>
      }
    >
      <EmployeeSelectorV2
        useAccessId
        value={userId}
        onChange={setUserId}
        forcedFilters={{ excludeIds: memberIds }}
      />
    </Modal>
  )
}
